// import i18n from '../i18n'

export default {
  // 星期
  yesOrNo: [
    { code: 0, description: '否' },
    { code: 1, description: '是' }
  ],
  // 星期
  week: [
    { code: 101, description: '周一' },
    { code: 102, description: '周二' },
    { code: 103, description: '周三' },
    { code: 104, description: '周四' },
    { code: 105, description: '周五' },
    { code: 106, description: '周六' },
    { code: 100, description: '周日' }
  ],
  // 星期
  week2: [
    { code: 1, description: '周一' },
    { code: 2, description: '周二' },
    { code: 3, description: '周三' },
    { code: 4, description: '周四' },
    { code: 5, description: '周五' },
    { code: 6, description: '周六' },
    { code: 7, description: '周日' }
  ],
  // 验证码类型
  smsStatus: [
    { code: 100, description: '注册' },
    { code: 101, description: '登录' },
    { code: 102, description: '忘记密码' },
    { code: 103, description: '手机绑定' },
    { code: 104, description: '邮箱绑定' },
    { code: 105, description: '微信绑定' }
  ],
  // 性别
  gender: [
    // { code: 100, description: '无' },
    { code: 101, description: '男' },
    { code: 102, description: '女' }
  ],
  // 校区状态
  campusStatus: [
    { code: 101, description: '使用中' },
    { code: 102, description: '已停用' }
  ],
  // 员工状态
  teacherStatus: [
    { code: 0, description: '已停用' },
    { code: 1, description: '使用中' }
  ],
  // 员工状态
  bindingStatus: [
    { code: 1, description: '已绑定' },
    { code: 0, description: '未绑定' }
  ],
  // 所在空间
  scope: [
    { code: 101, description: '总部' },
    { code: 102, description: '校区' }
  ],
  // 学员家人关系
  studentFamily: [
    { code: 100, description: '爸爸' },
    { code: 101, description: '妈妈' },
    { code: 102, description: '爷爷' },
    { code: 103, description: '奶奶' },
    { code: 104, description: '外公' },
    { code: 105, description: '外婆' },
    { code: 106, description: '阿姨' },
    { code: 107, description: '叔叔' },
    { code: 108, description: '哥哥' },
    { code: 109, description: '姐姐' },
    { code: 110, description: '家长' }
  ],
  // 在园离园
  studentStatus: [
    { code: 100, description: '在园' },
    { code: 101, description: '离园' }
  ],
  // 在园午餐
  lunchInSchool: [
    { code: 1, description: '在园午餐' },
    { code: 0, description: '不在园午餐' }
  ],
  // 消毒状态
  disinfectStatus: [
    { code: 1, description: '已消毒' },
    { code: 0, description: '未消毒' }
  ],
  // 适用地区
  canAddrList: [
    { canAddrName: '班1', canAddrId: 1 },
    { canAddrName: '班3', canAddrId: 12 },
    { canAddrName: '班4', canAddrId: 13 },
    { code: 100, description: '在园' },
    { code: 101, description: '离园' }
  ],
  // 方案状态
  schemeStatus: [
    { code: 101, description: '已设置' },
    { code: 102, description: '未设置' }
  ],
  // 晨检机类型
  machineTypes: [
    { code: 101, description: '沃柯雷克晨检机' },
    { code: 102, description: '超能晨检机' }
  ],
  // 适用能区
  fnZone: [
    { code: 201, description: '身体协调' },
    { code: 202, description: '平衡' },
    { code: 203, description: '肌力' },
    { code: 204, description: '灵敏性' },
    { code: 205, description: '柔韧性' },
    { code: 206, description: '心肺耐力' }
  ],
  // 未分组和分组
  studentGroup: [
    { code: 100, description: '未分组' },
    { code: 101, description: '已分组' }
  ],
  // 技巧管理
  skillType: [
    { code: 101, description: '蒙式工作' },
    { code: 102, description: '运动体能' },
    { code: 103, description: '绘本课程' }
  ],
  // 课程类型
  courseType: [
    { code: 101, description: '居家运动' },
    { code: 102, description: '科学实验' },
    { code: 103, description: '精细运动' }
  ],
  // 力台状态
  muscleOrientation: [
    { code: 100, description: '正面' },
    { code: 101, description: '背面' }
  ],
  // 肌肉类型
  muscleType: [
    { code: 100, description: '三角肌' },
    { code: 101, description: '肱二头肌' },
    { code: 102, description: '胸大肌' },
    { code: 103, description: '前臂肌群' },
    { code: 104, description: '腹肌' },
    { code: 105, description: '股四头肌' },
    { code: 106, description: '肱三头肌' },
    { code: 107, description: '竖脊肌' },
    { code: 108, description: '背阔肌' },
    { code: 109, description: '臀大肌' },
    { code: 110, description: '腘绳肌' },
    { code: 111, description: '小腿三头肌' },
    { code: 112, description: '心肺' },
    { code: 113, description: '神经系统' }
  ],
  // 教学计划内容
  termPlanContent: [
    { code: 100, description: '教学计划+月计划' },
    { code: 101, description: '教学计划+月计划+周计划' }
  ],
  // 班级类型
  classType: [
    { code: 101, description: '托班' }
    // { code: 100, description: '普通班' },
    // { code: 101, description: '蒙特梭利-IC班' },
    // { code: 102, description: '蒙特梭利-CASA班' }
  ],
  // 前肌肉类型
  muscleFrontType: [
    { code: 100, description: '三角肌' },
    { code: 101, description: '肱二头肌' },
    { code: 102, description: '胸大肌' },
    { code: 103, description: '前臂肌群' },
    { code: 104, description: '腹肌' },
    { code: 105, description: '股四头肌' },
    { code: 112, description: '心肺' },
    { code: 114, description: '肩部肌群' },
    { code: 115, description: '胸部肌群' }
  ],
  // 背肌肉类型
  muscleBackType: [
    { code: 100, description: '三角肌' },
    { code: 106, description: '肱三头肌' },
    { code: 107, description: '竖脊肌' },
    { code: 108, description: '背阔肌' },
    { code: 109, description: '臀大肌' },
    { code: 110, description: '腘绳肌' },
    { code: 111, description: '小腿三头肌' },
    { code: 113, description: '神经系统' },
    { code: 116, description: '肩部肌群' },
    { code: 117, description: '肩部旋转肌群' },
    { code: 118, description: '躯干胸背肌群' },
    { code: 119, description: '躯干腰背肌群' }
  ],
  // 手掌正面肌肉类型
  palmFrontType: [
    { code: 301, description: '屈指肌群(含掌內肌群)' }
  ],
  // 手掌背面肌肉类型
  palmBackType: [
    { code: 302, description: '伸指肌群(含掌內肌群)' }
  ],
  // 手臂正面肌肉类型
  armFrontType: [
    { code: 201, description: '上臂伸肌群' },
    { code: 202, description: '屈腕肌群' },
    { code: 203, description: '屈拇肌群' }
  ],
  // 手臂背面肌肉类型
  armBackType: [
    { code: 204, description: '上臂伸肌群(含肘肌)' },
    { code: 205, description: '伸腕肌群' },
    { code: 206, description: '伸拇肌群' }
  ],
  //  重要程度
  muscleImportance: [
    { code: 100, description: '主要' },
    { code: 101, description: '次要' }
  ],
  // 主题领域
  monthThemeList: [
    {
      code: 100, description: '生活活动'
    },
    {
      code: 101, description: '蒙氏工作'
    },
    {
      code: 102, description: '语言文化'
    },
    {
      code: 103, description: '艺术表现'
    },
    {
      code: 104, description: '运动健康'
    },
    {
      code: 105, description: '环境创设'
    },
    {
      code: 106, description: '家园共育'
    },
    {
      code: 107, description: '保健安全'
    },
    {
      code: 108, description: '节庆活动'
    }

  ],
  weekThemeList: [
    {
      code: 100, description: '蒙氏工作'
    },
    {
      code: 101, description: '运动体能'
    },
    {
      code: 102, description: '餐后活动'
    },
    {
      code: 103, description: '绘本课程'
    },
    {
      code: 104, description: '离园活动'
    },
    {
      code: 105, description: '环境创设'
    },
    {
      code: 106, description: '家园共育'
    }

  ],
  // 课程推送状态
  pushStatus: [
    { code: 102, description: '推送中' },
    { code: 101, description: '未推送' },
    { code: 103, description: '推送中' },
    { code: 104, description: '已结束' }
  ],
  // 出入园状态
  throughGateState: [
    { code: 101, description: '入园' },
    { code: 102, description: '出园' }
  ],
  // 出入员类型
  throughGateType: [
    { code: 101, description: '手动' },
    { code: 102, description: '扫码' }
  ],
  // 缺勤追踪
  absenceTrack: [
    { code: 103, description: '已追踪' },
    { code: 101, description: '未追踪' }
  ],
  // 类型
  sourceVoType: [
    { code: 101, description: '模版' },
    { code: 102, description: '内部' }
  ],
  // 设备是否默认
  equipDefault: [
    { code: 1, description: '设为默认' },
    { code: 0, description: '不选择' }
  ],
  // 是否在线
  online: [
    { code: 0, description: '离线' },
    { code: 1, description: '在线' }
  ],
  // 量表状态
  evaluationStatus: [
    { code: 100, description: '待上传' },
    { code: 101, description: '已生成' },
    { code: 102, description: '生成中' },
    { code: 103, description: '生成失败' },
    { code: 104, description: '有更新' }
  ],
  // 适应能区
  energyType: [
    { code: 100, description: '上肢力量' },
    { code: 101, description: '柔韧性' },
    { code: 102, description: '动态平衡' },
    { code: 103, description: '静态平衡' },
    { code: 104, description: '下肢力量' },
    { code: 105, description: '灵敏性' },
    { code: 106, description: '心肺耐力' },
    { code: 107, description: '身体协调' }
  ],
  // 职位
  jobList: [
    { code: 101, description: '园长' },
    { code: 102, description: '保教主任' },
    { code: 103, description: '后勤主任' },
    { code: 104, description: '保教老师' }
  ],
  // tab列表
  tabList: [
    { code: 101, description: '保教' },
    { code: 102, description: '管理' },
    { code: 103, description: '教学' },
    { code: 104, description: '运动' },
    { code: 105, description: '我的' }
  ],
  // 教案包类型
  teachPackageType: [
    { code: 101, description: '蒙氏工作' },
    { code: 102, description: '运动体能' },
    { code: 103, description: '绘本课程' },
    { code: 104, description: '其他' }
  ],
  // 运动课程类型
  exerciseType: [
    { code: 101, description: '运动' },
    { code: 102, description: '创意美术' },
    { code: 103, description: '科学实验' }
  ],
  // 适用类型
  suitType: [
    { code: 101, description: '托幼' },
    { code: 102, description: '幼儿' }
  ],
  // 适用体能
  suitEnergyType: [
    { code: 101, description: '身体协调' },
    { code: 102, description: '平衡' },
    { code: 103, description: '肌力' },
    { code: 104, description: '灵敏性' },
    { code: 105, description: '柔韧性' },
    { code: 106, description: '心肺耐力' }
  ],
  // 复检状态
  recheckStatus: [
    { code: 1, description: '已复检' },
    { code: 0, description: '未复检' }
  ],
  // 是否合格
  qualified: [
    { code: 1, description: '合格' },
    { code: 0, description: '不合格' }
  ],
  // 入园档案
  hadInSchoolRecord: [
    { code: 1, description: '已登记' },
    { code: 0, description: '未登记' }
  ],
  // 录入状态
  recordStatus: [
    { code: 101, description: '未记录' },
    { code: 103, description: '已记录' }
  ],
  // 录入状态
  checkStatus: [
    { code: 101, description: '未记录' },
    { code: 103, description: '已记录' }
  ],
  // 验收状态
  checkAcceptStatus: [
    { code: 101, description: '未验收' },
    { code: 103, description: '已验收' }
  ],
  // 考勤状态
  attendanceStatus: [
    { code: 101, description: '未签到' },
    { code: 103, description: '已签到' }
  ],
  // 检查状态
  isCheck: [
    { code: 1, description: '已检查' },
    { code: 0, description: '未检查' }
  ],
  // 敏感期（多选）
  sensitiveList: [
    { code: 101, description: '秩序' },
    { code: 102, description: '语言' },
    { code: 103, description: '感官紧致化' },
    { code: 104, description: '动作协调' },
    { code: 105, description: '社会行为' },
    { code: 106, description: '细小事物' }
  ],
  // 自助与习惯
  selfHabit: [
    { code: 1, description: '愿意尝试自己吃饭', select: false },
    { code: 2, description: '能独立使用餐具', select: false },
    { code: 3, description: '能吃完自己的一份食物', select: false },
    { code: 4, description: '不挑食，接受大部分实物', select: false },
    { code: 5, description: '知道使用毛巾擦嘴', select: false },
    { code: 6, description: '有自己收拾餐具的意识', select: false }
  ],
  // 情感与社会
  emotional: [
    { code: 1, description: '接受短暂的亲子分离', select: false },
    { code: 2, description: '能接受其他熟悉人员的照料', select: false },
    { code: 3, description: '与主要照料者积极互动', select: false },
    { code: 4, description: '在熟悉的环境下，能适应、接受陌生人在场', select: false },
    { code: 5, description: '哭的次数明显减少', select: false },
    { code: 6, description: '可以简单表达自己的情绪', select: false }
  ],
  // 性别
  dpaEvaluationStatus: [
    { code: 100, description: '未开始' },
    { code: 101, description: '已完成' },
    { code: 102, description: '进行中' }
  ],
  // 疾病类型
  sickType: [
    { code: 100, description: '营养不良' },
    { code: 101, description: '贫血' },
    { code: 102, description: '单纯性肥胖' },
    { code: 103, description: '先心病' },
    { code: 104, description: '哮喘' },
    { code: 105, description: '癫痫' },
    { code: 106, description: '听力障碍' },
    { code: 107, description: '视力低常' },
    { code: 108, description: '龋齿' },
    { code: 109, description: '其它' }
  ],
  // 传染病类型
  epidemicType: [
    { code: 100, description: '手足口病' },
    { code: 101, description: '水痘' },
    { code: 102, description: '流行性腮腺炎' },
    { code: 103, description: '猩红热' },
    { code: 104, description: '急性出血性结膜炎' },
    { code: 105, description: '痢疾' },
    { code: 106, description: '麻疹' },
    { code: 107, description: '风疹' },
    { code: 108, description: '传染性肝炎' },
    { code: 109, description: '传染性腹泻' },
    { code: 110, description: '其它' }
  ],
  // 伤害类型
  hurtType: [
    { code: 100, description: '交通事故' },
    { code: 101, description: '跌伤（跌、摔、滑、绊）' },
    { code: 102, description: '被下落物击中（高处落下物）' },
    { code: 103, description: '锐器伤（刺、割、扎、划）' },
    { code: 104, description: '钝器伤（碰、砸）' },
    { code: 105, description: '烧烫伤（火焰、高温固/液体、化学物质、锅炉、烟火、爆竹炸伤）' },
    { code: 106, description: '溺水（经医护人员救治存活）' },
    { code: 107, description: '动物伤害（狗、猫、蛇等咬伤、蜜蜂、黄蜂等刺蜇）' },
    { code: 108, description: '窒息（异物，压、闷、捂窒息，鱼刺/骨头卡喉）' },
    { code: 109, description: '中毒（药品、化学物质、一氧化碳等有毒气体,农药,鼠药,杀虫剂，腐败变质食物除外）' },
    { code: 110, description: '电击伤（触电、雷电）' },
    { code: 111, description: '他伤/攻击伤' }
  ],
  // 伤害发生地
  hurtHappenPlace: [
    { code: 100, description: '户外活动场' },
    { code: 101, description: '活动室' },
    { code: 102, description: '寝室' },
    { code: 103, description: '卫生间' },
    { code: 104, description: '盥洗室' },
    { code: 105, description: '其他' }
  ],
  // 伤害发生时活动
  hurtActivity: [
    { code: 100, description: '玩耍娱乐' },
    { code: 101, description: '吃饭' },
    { code: 102, description: '睡觉' },
    { code: 103, description: '上厕所' },
    { code: 104, description: '洗澡' },
    { code: 105, description: '行走' },
    { code: 106, description: '乘车' },
    { code: 107, description: '其他' },
    { code: 108, description: '不知道' }
  ],
  // 伤害发生时和谁在一起
  hurtEscort: [
    { code: 100, description: '独自一人' },
    { code: 101, description: '老师' },
    { code: 102, description: '小伙伴' },
    { code: 103, description: '其他' },
    { code: 104, description: '不知道' }
  ],
  // 受伤后处理方式
  hurtDealType: [
    { code: 100, description: '自行处理（保健人员）且未再就诊' },
    { code: 101, description: '医疗卫生机构就诊' },
    { code: 102, description: '其他' }
  ],
  // 转归
  traineeReturn: [
    { code: 101, description: '痊愈' },
    { code: 102, description: '好转' },
    { code: 103, description: '残疾' },
    { code: 104, description: '死亡' },
    { code: 105, description: '其他' }
  ],
  // 出勤状态
  attendanceStaticStatus: [
    { code: 100, description: '出勤' },
    { code: 101, description: '缺勤' },
    { code: 102, description: '病假' },
    { code: 103, description: '事假' }
  ],
  // 缺勤类型
  absenceType: [
    { code: 100, description: '病假' },
    { code: 101, description: '事假' },
    { code: 102, description: '寒暑假' },
    { code: 103, description: '其他' }
  ],
  // 疾病类型
  diseaseType: [
    { code: 100, description: '常见疾病' },
    { code: 101, description: '传染病' }
  ],
  // 常见疾病名称类型
  normalSicknessType: [
    { code: 100, description: '上呼吸道感染' },
    { code: 101, description: '咳嗽' },
    { code: 102, description: '咽喉炎' },
    { code: 103, description: '扁桃体炎' },
    { code: 114, description: '其它' }
  ],
  // 传染病名称类型
  specialSicknessType: [
    { code: 104, description: '手足口病' },
    { code: 105, description: '水痘' },
    { code: 106, description: '流行性腮腺炎' },
    { code: 107, description: '猩红热' },
    { code: 108, description: '急性出血性结膜炎' },
    { code: 109, description: '痢疾' },
    { code: 110, description: '麻疹' },
    { code: 111, description: '风疹' },
    { code: 112, description: '传染性肝炎' },
    { code: 113, description: '传染性腹泻' },
    { code: 114, description: '其它' }
  ],
  // 公告通知
  noticeStatus: [
    { code: 100, description: '未发布' },
    { code: 101, description: '已发布' }
  ],
  // 公告发布平台
  noticePublishType: [
    { code: 100, description: '全平台' },
    { code: 101, description: '教师端' },
    { code: 102, description: '家长端' }
  ],
  // 采集状态
  collectStatus: [
    { code: 100, description: '未开始' },
    { code: 101, description: '已完成' },
    { code: 102, description: '进行中' }
  ],
  // 年龄段
  classAgeType: [
    { code: 101, description: '小班' },
    { code: 102, description: '中班' },
    { code: 103, description: '大班' }
  ],
  // 年龄段
  ageType: [
    { code: 101, description: '小龄组' },
    { code: 102, description: '中龄组' },
    { code: 103, description: '大龄组' }
  ],
  // 分组状态
  groupStatus: [
    { code: 101, description: '待开班' },
    { code: 102, description: '开班中' },
    { code: 103, description: '已结班' }
  ],
  // 课程开课状态
  courseOpenStatus: [
    { code: 101, description: '开课中' },
    { code: 102, description: '未开课' }
  ],
  // 打卡统计时间类型
  signDateType: [
    { code: 101, description: '天' },
    { code: 102, description: '周' },
    { code: 103, description: '月' }
  ],
  // 岗位类型
  postType: [
    { code: 101, description: '管理年级' },
    { code: 102, description: '管理年龄组' },
    { code: 103, description: '管理班级' },
    { code: 104, description: '管理分组' }
  ],
  // 年级类型
  classroomTypes: [
    { code: 101, description: '小班' },
    { code: 102, description: '中班' },
    { code: 103, description: '大班' }
  ],
  // 年龄组类型
  ageTypes: [
    { code: 101, description: '小龄' },
    { code: 102, description: '中龄' },
    { code: 103, description: '大龄' }
  ],
  // 自定义群组类型
  customGroupType: [
    { code: 101, description: '学员' },
    { code: 102, description: '年龄' },
    { code: 103, description: '时间' },
    { code: 104, description: '评估计划' }
  ],
  // 自定义群组类型
  compareType: [
    { code: 101, description: '年级对比' },
    { code: 102, description: '性别对比' },
    { code: 103, description: '班级对比' },
    { code: 104, description: '自定义对比' }
  ],
  // 群体分析-年龄类型
  groupAnalysisAgeType: [
    { code: 101, description: '3-4岁' },
    { code: 102, description: '4-5岁' },
    { code: 103, description: '5-6岁' },
    { code: 104, description: '6岁以上' }
  ],
  // 群体分析-身高类型
  heightType: [
    { code: 100, description: '很矮' },
    { code: 101, description: '较矮' },
    { code: 102, description: '一般' },
    { code: 103, description: '较高' },
    { code: 104, description: '很高' }
  ],
  // 群体分析-身高类型
  weightType: [
    { code: 100, description: '较瘦' },
    { code: 101, description: '正常' },
    { code: 102, description: '超重' },
    { code: 103, description: '肥胖' }
  ],
  zoneType: [
    { code: 103, description: '心肺耐力' },
    { code: 104, description: '上肢力量' },
    { code: 105, description: '下肢力量' },
    { code: 106, description: '身体平衡' },
    { code: 107, description: '身体灵敏' }
  ],
  zoneLevelType: [
    { code: 101, description: '优秀' },
    { code: 102, description: '良好' },
    { code: 103, description: '一般' },
    { code: 104, description: '较差' },
    { code: 105, description: '很差' }
  ],
  // 分析维度
  analysisType: [
    { code: 101, description: '班级维度' },
    { code: 102, description: '年级维度' }
  ],
  // 打卡时间类型
  signTimeType: [
    { code: 101, description: '天' },
    { code: 102, description: '周' },
    { code: 103, description: '月' },
    { code: 104, description: '自定义' }
  ],
  // 打卡时间类型
  orgEvaluationStatus: [
    { code: 100, description: '天' },
    { code: 101, description: '周' },
    { code: 102, description: '月' }
  ]
}
